import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaSyncAlt } from "react-icons/fa";
import logo from "../assets/logo.png";
import { fetchVillageJson } from "../utils/villageData";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isRandomLoading, setIsRandomLoading] = useState(false);
  const hideMobileFab = location.pathname.includes("/census-2027-upcoming");

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/india-census-2011", label: "India Data" },
    { path: "/census-2027-upcoming", label: "Census Help" },
    { path: "random", label: "Random Explore" },
    { path: "/contact", label: "Contact Us" },
  ];

  const handleRandomExplore = async () => {
    let attempts = 0;
    const maxAttempts = 5;

    setIsRandomLoading(true);

    while (attempts < maxAttempts) {
      try {
        const statesData = await fetchVillageJson("states.json");
        const states = Array.isArray(statesData) ? statesData : (statesData.states || []);
        const state = states[Math.floor(Math.random() * states.length)];
        if (!state?.slug) throw new Error("No valid states found");

        const religionData = await fetchVillageJson(`${state.slug}/districtReligionData.json`);
        const districts = religionData.districts;

        if (!districts || districts.length === 0) throw new Error("No districts found");
        const district = districts[Math.floor(Math.random() * districts.length)];
        const districtSlug = district.districtSlug;

        if (!districtSlug) throw new Error("Invalid district slug");

        const isSubdistrict = Math.random() > 0.5;

        if (isSubdistrict) {
          if (!district.subdistricts || district.subdistricts.length === 0) {
            navigate(`/religion/${state.slug}/${districtSlug}`);
          } else {
            const sub = district.subdistricts[Math.floor(Math.random() * district.subdistricts.length)];
            const subSlug = sub.slug || sub.name.toLowerCase().replace(/ /g, '-');
            navigate(`/religion/${state.slug}/${districtSlug}/${subSlug}`);
          }
        } else {
          navigate(`/religion/${state.slug}/${districtSlug}`);
        }

        setIsRandomLoading(false);
        setIsMobileMenuOpen(false);
        return;

      } catch (err) {
        console.warn(`Random Attempt ${attempts + 1} failed:`, err.message);
        attempts++;
      }
    }

    setIsRandomLoading(false);
    navigate("/");
  };

  const handleScrollNav = (id) => {
    if (id === "random") {
      handleRandomExplore();
      return;
    }

    if (id.startsWith("/")) {
      navigate(id);
    } else if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="navbar sticky-top py-3">
        <div className="container d-flex align-items-center justify-content-between">
          <Link to="/" className="navbar-brand d-flex align-items-center text-decoration-none">
            <img src={logo} alt="Logo" className="me-2 rounded-circle shadow-sm border border-light" width="42" height="42" />
            <div>
              <div className="fw-bold fs-4 text-dark" style={{ letterSpacing: "-0.03em" }}>
                <span style={{ color: "#2563eb" }}>All India</span> <span style={{ color: "#0f172a" }}>Census</span>
              </div>
            </div>
          </Link>

          <nav className="d-none d-lg-flex align-items-center position-relative">
            {navItems.map((item) => (
              <button
                key={item.label}
                disabled={isRandomLoading && item.path === "random"}
                className={`btn btn-link nav-link mx-2 text-decoration-none border-0 ${location.pathname === item.path ? "fw-bold text-primary" : "text-dark"
                  }`}
                onClick={() => handleScrollNav(item.path)}
              >
                {isRandomLoading && item.path === "random" ? "Loading..." : item.label}
              </button>
            ))}
          </nav>

          <div className="d-flex align-items-center d-lg-none gap-2">
            <button
              className="btn"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <FaTimes className="fs-3 text-primary" />
              ) : (
                <FaBars className="fs-3 text-primary" />
              )}
            </button>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-white"
          style={{ zIndex: 1050 }}
        >
          <div className="container py-4">
            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
              <strong className="fs-5 text-primary">All India Census</strong>
              <button className="btn p-0" onClick={() => setIsMobileMenuOpen(false)}>
                <FaTimes className="fs-3 text-primary" />
              </button>
            </div>

            <div className="d-flex flex-column gap-2">
              {navItems.map((item) => (
                <button
                  key={item.label}
                  disabled={isRandomLoading && item.path === "random"}
                  className="d-flex align-items-center w-100 py-3 border-0 bg-transparent fs-5 text-start border-bottom"
                  onClick={() => handleScrollNav(item.path)}
                >
                  <span className={location.pathname === item.path ? "text-primary fw-bold" : "text-dark"}>
                    {isRandomLoading && item.path === "random" ? "Picking Religion Page..." : item.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {!hideMobileFab && (
        <div className="d-lg-none position-fixed bottom-0 end-0 m-3" style={{ zIndex: 1100 }}>
          <button
            className="btn btn-primary rounded-circle shadow-lg d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px", transition: 'all 0.3s ease' }}
            onClick={() => handleRandomExplore()}
            disabled={isRandomLoading}
          >
            {isRandomLoading ? (
              <div className="spinner-border spinner-border-sm text-white" role="status"></div>
            ) : (
              <FaSyncAlt className="text-white" style={{ fontSize: '1rem' }} />
            )}
          </button>
        </div>
      )}
    </>
  );
};

export default Header;
